import { atom } from "jotai";

export const isStreamingZslAtom = atom<boolean>(false);
isStreamingZslAtom.debugLabel = "isStreamingZslAtom";

export const isPromptToZslCompleteAtom = atom<boolean | null>(null);
isPromptToZslCompleteAtom.debugLabel = "isPromptToZslCompleteAtom";

export const promptToZslErrorAtom = atom<string>("");
promptToZslErrorAtom.debugLabel = "promptToZslErrorAtom";
